import { render, staticRenderFns } from "./ShiftsItem2.vue?vue&type=template&id=2cc1ccfa&lang=pug"
import script from "./ShiftsItem2.vue?vue&type=script&lang=js"
export * from "./ShiftsItem2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports